import { actionTypes as shelfLifeUpdateActionTypes } from '../../../actions/Dialogs/ShelfLifeUpdateDialog/shelfLifeUpdateDialogActions.js';
import { Map, List } from 'immutable';


let defaultState = {

  show: false,
  loading: false,
  assets : Map(),
  preselectedAssets: List(),
  entitiesTypes: List(),
  boEntityFilter: '',
  cancelToken: '',
  reasons: []
};


export default function(state = Map(defaultState), action) {

  switch(action.type) {
    case shelfLifeUpdateActionTypes.SHELFLIFEUPDATE_DIALOG_FETCH_REASONS_READY:
      return state.setIn(["reasons"], action.payload.map((obj)=> { return { value: obj.id, label: obj.type } }));

    case shelfLifeUpdateActionTypes.SHELFLIFEUPDATE_DIALOG_FETCH_ASSETS_READY:
      return state.setIn(["assets", action.payload.assetType.toLowerCase()], action.payload.dataList );

    case shelfLifeUpdateActionTypes.SHELFLIFEUPDATE_DIALOG_SUBMIT_IN_PROGRESS:
      return state.set("loading", true);

    case shelfLifeUpdateActionTypes.SHELFLIFEUPDATE_DIALOG_SUBMIT_FINISHED:
      return state.set("loading", false);

    case shelfLifeUpdateActionTypes.SHELFLIFEUPDATE_DIALOG_SHOW:
      return state.set('preselectedAssets', action.payload && action.payload.preselectedAssets ? List(action.payload.preselectedAssets) : List())
        .set('entitiesTypes', action.payload && action.payload.entitiesTypes ? List(action.payload.entitiesTypes) : List())
        .set('boEntityFilter', action.payload && action.payload.boEntityFilter ? action.payload.boEntityFilter : '')
        .set('show', true);

    case shelfLifeUpdateActionTypes.SHELFLIFEUPDATE_DIALOG_HIDE:
      return Map(defaultState);

      case shelfLifeUpdateActionTypes.SHELFLIFEUPDATE_DIALOG_SAVE_CANCEL_TOKEN:
      return state.set("cancelToken", action.payload);

    case shelfLifeUpdateActionTypes.SHELFLIFEUPDATE_DIALOG_SET_VALIDATION_WARNINGS_DATA:
      return state.set('validationMessage', action.payload)
        .set('hasError', !!action.payload.errors)
        .set('showIgnoreValidationCheckbox', !action.payload.errors)
        .set('hasHighSeverityWarning', action.payload.reset ? false : action.payload.hasHighSeverityWarning)
        .set('hasMediumSeverityWarning', action.payload.reset ? false : action.payload.hasMediumSeverityWarning)
        .set('isIgnoreValidationWarnings', false);

    case shelfLifeUpdateActionTypes.SHELFLIFEUPDATE_DIALOG_HIDE_IGNORE_VALIDATION_WARNINGS_CHECKBOX:
      return state.set('showIgnoreValidationCheckbox', false)
        .set('hasHighSeverityWarning', false)
        .set('hasMediumSeverityWarning', false)
        .set('hasError', false)
        .set('isIgnoreValidationWarnings', false);

    case shelfLifeUpdateActionTypes.SHELFLIFEUPDATE_DIALOG_TOGGLE_IGNORE_VALIDATION_WARNINGS_CHECKBOX:
      return state.set('isIgnoreValidationWarnings', action.payload);

    default:
      return state;
  }
}


